import { useNavigate } from "react-router-dom";
import GeneralBlockListItem from "./GeneralBlockListItem";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { GET_GENERAL_BLOCK_DEFAULT_PAGE_SIZE } from "../../../utils/constants";
import { isEqual, removeEmptyStringKeys } from "../../../utils/helper";
import queryString from "query-string";
import { getGeneralBlocks } from "../../../core/actionCreators/blocksActionCreator";
import CommonPagination from "../CommonPagination/CommonPagination";
import Loader from "../Loader/Loader";

const GeneralBlockList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { generalBlocks, isLoading } = useSelector((s: any) => s.blocksStore);

    const [searchCriteria, setSearchCriteria] = useState({
        id: "",
        name: "",
        title: "",
        label: "",
        status: "",
        pageNumber: 0,
        pageSize: GET_GENERAL_BLOCK_DEFAULT_PAGE_SIZE,
    } as any);

    const previousSearchCriteriaRef = useRef(searchCriteria);

    useEffect(() => {
        const updatedSearchCriteria = removeEmptyStringKeys(searchCriteria);
        const stringifiedSearchCriteria = queryString.stringify(updatedSearchCriteria);
        const previousCriteria = previousSearchCriteriaRef.current;
        const searchFilterChanged = !isEqual(updatedSearchCriteria, previousCriteria);

        if (searchFilterChanged) {
            const parsedSearchCriteria: any = queryString.parse(stringifiedSearchCriteria)
            for (let key in parsedSearchCriteria) {
                if (["id", "name", "title", "label", "status"].includes(key)) {
                    parsedSearchCriteria.pageNumber = 0
                    break
                }
            }
            dispatch(getGeneralBlocks(queryString.stringify(parsedSearchCriteria), null));
            previousSearchCriteriaRef.current = updatedSearchCriteria; // Update previous criteria
        }
    }, [searchCriteria]);


    const onPageChange = (pageNumber: any) => {
        setSearchCriteria({ ...searchCriteria, pageNumber: pageNumber })
    }

    const navigateToCreateGeneralBlockHandler = () => {
        navigate('/blocks/general/create');
    }

    return (
        <>
            <div className="flex justify-between items-center pt-4 px-4">
                <p className="text-base text-[#343434]">General Blocks</p>
                <button onClick={navigateToCreateGeneralBlockHandler} className="h-9 py-2 px-4 bg-blue-500 text-white font-semibold rounded shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75">Create General Blocks</button>
            </div>
            <div className="mt-4 campaign-list bg-white mb-[54px]">
                <table className="w-full" >
                    <thead className="bg-[#343434]">
                        <tr>
                            <th className="px-4 py-3 text-left text-xs font-semibold text-white w-[8%]">ID</th>
                            <th className="px-4 py-3 text-left text-xs font-semibold text-white w-[12%]">Label</th>
                            <th className="px-4 py-3 text-left text-xs font-semibold text-white w-[28%]"> Name</th>
                            <th className="px-4 py-3 text-left text-xs font-semibold text-white w-[10%]">Status</th>
                            <th className="px-4 py-3 text-left text-xs font-semibold text-white w-[13%]">Created At</th>
                            <th className="px-4 py-3 text-left text-xs font-semibold text-white w-[13%]">Updated At</th>
                            <th className="px-4 py-3 text-left text-xs font-semibold text-white w-[8%]">Update</th>
                            <th className="px-4 py-3 text-left text-xs font-semibold text-white w-[8%]">Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="px-4 py-3 text-left text-xs text-white w-[8%]">
                                <input value={searchCriteria.id}
                                    onChange={(e) =>
                                        setSearchCriteria({ ...searchCriteria, id: e.target.value })
                                    }
                                    className="w-full h-7 rounded border text-[#3c3c3c] border-[#EAEAEA] p-1 outline-none text-xs"
                                    type="text"
                                />
                            </td>
                            <td className="px-4 py-3 text-left text-xs text-white w-[12%]">
                            </td>
                            <td className="px-4 py-3 text-left text-xs text-white w-[20%]">
                                <input value={searchCriteria.name}
                                    onChange={(e) =>
                                        setSearchCriteria({ ...searchCriteria, name: e.target.value })
                                    } className="w-full h-7 rounded border text-[#3c3c3c] border-[#EAEAEA] p-1 outline-none text-xs"
                                    type="text"
                                />
                            </td>
                            <td className="px-4 py-3 text-left text-xs text-white w-[10%]">
                                <select
                                    value={searchCriteria.status}
                                    onChange={(e) =>
                                        setSearchCriteria({
                                            ...searchCriteria,
                                            status: e.target.value,
                                        })
                                    }
                                    className="w-full h-7 rounded border text-[#3c3c3c] border-[#EAEAEA] p-1 outline-none text-xs bg-white"
                                >
                                    <option>Select An Option</option>
                                    <option value={"true"}>True</option>
                                    <option value={"false"}>False</option>
                                </select>
                            </td>
                            <td className="px-4 py-3 text-left text-xs text-white w-[13%]">
                            </td>
                            <td className="px-4 py-3 text-left text-xs text-white w-[13%]">
                            </td>
                            <td className="px-4 py-3 text-left text-xs text-white w-[16%]">
                            </td>
                            <td className="px-4 py-3 text-left text-xs text-white w-[8%]">
                            </td>
                        </tr>
                        {isLoading ? (
                            <Loader />
                        ) : (
                            <GeneralBlockListItem data={generalBlocks?.data || []} />
                        )}
                    </tbody>
                </table>
            </div>
            {generalBlocks?.data && (
                <CommonPagination
                    data={generalBlocks}
                    PAGE_SIZE={GET_GENERAL_BLOCK_DEFAULT_PAGE_SIZE}
                    onPageChange={onPageChange}
                />
            )}
        </>
    )
}
export default GeneralBlockList;